import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImages1Alt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconImages1Alt"><Path d="M3.5 3.5L20.5 3.5V20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 11.5C15.6046 11.5 16.5 10.6046 16.5 9.5C16.5 8.39543 15.6046 7.5 14.5 7.5C13.3954 7.5 12.5 8.39543 12.5 9.5C12.5 10.6046 13.3954 11.5 14.5 11.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M3.75 16.25L8 12L16.25 20.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconImages1Alt;
